import type { TargetareDimensiune, TargetareTier } from "@/types/targetare";

const FORMAT_NUMAR = new Intl.NumberFormat("ro-RO", {
  maximumFractionDigits: 0,
});

export const TIER_LABELS: Record<TargetareTier, string> = {
  A: "A · CAEN principal + dimensiune",
  B: "B · Listă oficială + dimensiune",
  C: "C · Indiferent de dimensiune",
  D: "D · Doar dimensiune",
};

export const TIER_DESCRIERI: Record<TargetareTier, string> = {
  A: "Firmă mijlocie sau mare cu CAEN principal într-un serviciu NIS2",
  B: "Firmă mijlocie sau mare prezentă pe o listă de autorizați",
  C: "Serviciu în scop indiferent de dimensiune (art. 5–6 OUG 155/2024)",
  D: "Firmă mijlocie sau mare doar cu coduri CAEN autorizate secundare",
};

export const DIMENSIUNE_LABELS: Record<TargetareDimensiune, string> = {
  micro: "Micro",
  mica: "Mică",
  mijlocie: "Mijlocie",
  mare: "Mare",
};

export function formatNumar(valoare: number | null | undefined): string {
  if (valoare === null || valoare === undefined) return "–";
  return FORMAT_NUMAR.format(valoare);
}

export function formatRon(valoare: number | null | undefined): string {
  if (valoare === null || valoare === undefined) return "–";
  if (Math.abs(valoare) >= 1_000_000) {
    return `${(valoare / 1_000_000).toLocaleString("ro-RO", {
      maximumFractionDigits: 1,
    })} mil. lei`;
  }
  return `${FORMAT_NUMAR.format(valoare)} lei`;
}

export function formatDimensiune(
  dimensiune: TargetareDimensiune | null | undefined
): string {
  if (!dimensiune) return "necunoscută";
  return DIMENSIUNE_LABELS[dimensiune] ?? dimensiune;
}

export function formatDataOra(valoare: string | null | undefined): string {
  if (!valoare) return "–";
  const data = new Date(valoare);
  if (Number.isNaN(data.getTime())) return valoare;
  return data.toLocaleString("ro-RO", {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function descarcaFisierText(
  continut: string,
  numeFisier: string,
  tipMime = "text/csv;charset=utf-8"
): void {
  const blob = new Blob([continut], { type: tipMime });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = numeFisier;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
